module.exports = __webpack_public_path__ + "img/kids.0417cd2f.jpeg";